module.exports = __webpack_public_path__ + "img/CertificadoHelp.c2941022.png";